// @flow

import { useAction, useAtom } from '@reatom/react'
import { hideWarning, messagesAtom } from '@bfg/atoms/Util'

export const useWarnings = () => {
  const messagesState = useAtom(messagesAtom)

  const warnings = messagesState.warning
  const dismissWarnings = useAction(() => hideWarning())

  return { warnings, dismissWarnings }
}